import { AfterViewInit, Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { PrefixValidator } from "../../PrefixValidator";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  selector: "app-prefix-ba2",
  standalone: true,
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-ba2.component.html",
  styleUrl: "./prefix-ba2.component.less",
})
export class PrefixBa2Component extends PrefixTextComponent implements AfterViewInit {
  public constructor() {
    super();
    this.counter = false;
    this.characters = ALLOWED_CHARACTERS["ba2"];
    this.required = true;
  }

  public ngAfterViewInit(): void {
    this.control.addValidators(PrefixValidator.iban());
    this.control.updateValueAndValidity();
  }
}
